// src/components/UserAvatar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import md5 from 'blueimp-md5';

export default function UserAvatar({ user, size = 40, className = '' }) {
  if (!user) return null;

  const email = user.email || '';
  const hash = email ? md5(email.trim().toLowerCase()) : '';
  const src = user.avatarProvider === 'gravatar' || !user.avatarProvider
    ? (hash
        ? `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`
        : '/placeholder-avatar.jpg')
    : '/placeholder-avatar.jpg'; // fallback or logic for other providers

  return (
    <img
      src={src}
      className={`rounded-circle ${className}`}
      width={size}
      height={size}
      alt={email}
    />
  );
}

UserAvatar.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    avatarProvider: PropTypes.string,
  }),
  size: PropTypes.number,
  className: PropTypes.string,
};
